import {
  SIGN_OUT,
  GET_EXPENSES,
  CLEAR_EXPENSES,
  VOID_TICKET_DIALOG,
  SHOW_VOID_TICKET_DIALOG,
  HIDE_VOID_TICKET_DIALOG,
  UPDATE_EXPENSES_AFTER_VOID_ROAD_TICKET
} from "../constants/ActionTypes";

const INIT_STATE = {
  expenses: {
    data: [],
    count: 0
  },
  voidingTransaction: {
    isVoidingTransaction: false,
    currentVoidingTransaction: null
  },
  shouldUpdateExpenses: false,
  locallyVoidedTransactionUuids: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SIGN_OUT: {
      return INIT_STATE;
    }

    case GET_EXPENSES: {
      return {
        ...state,
        expenses: action.payload,
      };
    }

    case CLEAR_EXPENSES: {
      return INIT_STATE;
    }

    case VOID_TICKET_DIALOG: {
      return {
        ...state,
        locallyVoidedTransactionUuids: [
          ...state.locallyVoidedTransactionUuids,
          action.payload.walletTransactionUuid,
        ],
      };
    }

    case UPDATE_EXPENSES_AFTER_VOID_ROAD_TICKET: {
      return {
        ...state,
        shouldUpdateExpenses: true,
      };
    }

    case SHOW_VOID_TICKET_DIALOG: {
      const uuid = action.payload;

      return {
        ...state,
        voidingTransaction: {
          isVoidingTransaction: true,
          currentVoidingTransaction: uuid
        },
        shouldUpdateExpenses: false,
      };
    }

    case HIDE_VOID_TICKET_DIALOG: {
      return {
        ...state,
        voidingTransaction: {
          isVoidingTransaction: false,
          currentVoidingTransaction: null,
        },
        shouldUpdateExpenses: false,
      };
    }

    default:
      return state;
  }
}
